module.exports = __webpack_public_path__ + "img/banner_image2.bc7bd189.jpg";